// Clock face, used on the "waiting Nd" age chip where a sheet has been submitted but nobody has acted on it yet.
// Decorative — the control it sits in carries the accessible name, so the glyph
// is aria-hidden. Size via CSS font-size (renders at 1em); color via currentColor.
export function ClockIcon({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...(className ? { className } : {})}
    >
      <circle cx="12" cy="12" r="9" />
      <polyline points="12 7 12 12 15.5 14" />
    </svg>
  );
}
